import React from "react";
import {
  IItemCarrito,
  isItemCarritoGuarderia,
  isItemCarritoHotel,
  isItemCarritoSpa,
  ItemCarrito,
} from "../../../services/carritoServicios";

import { InfoRow } from "../../organisms/InfoRow";
import { ItemGuarderia } from "./ItemGuarderia";
import { ItemHotel } from "./ItemHotel";
import { ItemSpa } from "./ItemSpa";
import { CarritoHandlers } from "./Model";

export const SeccionMascota = ({
  mascota,
  items,
  handlers,
}: {
  mascota: IItemCarrito["mascota"];
  items: Array<ItemCarrito>;
  handlers: CarritoHandlers;
}) => {
  return (
    <section className="mb-4">
      <section className="mb-4">
        <InfoRow label="Nombre" value={mascota.nombre} />
        <InfoRow label="Edad" value={mascota.edad} />
        <InfoRow label="Raza" value={mascota.raza} />
      </section>
      {items.map((i) => {
        const onEliminarItemClick = () => {
          handlers.eliminarItem({ idMascota: i.mascota.id, idItem: i.id });
        };
        if (isItemCarritoGuarderia(i)) {
          return (
            <ItemGuarderia
              onEliminarItemClick={onEliminarItemClick}
              key={i.id}
              item={i}
              handlers={handlers.guarderia}
            />
          );
        }
        if (isItemCarritoHotel(i)) {
          return (
            <ItemHotel
              onEliminarItemClick={onEliminarItemClick}
              key={i.id}
              item={i}
              handlers={handlers.hotel}
            />
          );
        }
        if (isItemCarritoSpa(i)) {
          return (
            <ItemSpa
              onEliminarItemClick={onEliminarItemClick}
              key={i.id}
              item={i}
              handlers={handlers.spa}
            />
          );
        }
        return <></>;
      })}
    </section>
  );
};
